import { useEffect } from "react";
import { defaultProject, projectAtomList } from "../../atoms";
import { useAtom } from "jotai";

export const ResetJotai = ({ reset }) => {
  const [, setCurrentProject] = useAtom(projectAtomList);

  useEffect(() => {
    if (reset) {
      setCurrentProject(defaultProject);
    }
  }, [reset, setCurrentProject]);

  

  return null;
};